import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class InactivityService {
  private timeoutId: any;
  private readonly timeoutMs = 20 * 60 * 1000; // 20 minutes
  private activityChannel: BroadcastChannel;

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private authService: AuthService,
    private http: HttpClient
  ) {
    this.activityChannel = new BroadcastChannel('user-activity');
    this.activityChannel.onmessage = (event) => {
      if (event.data === 'activity') {
        this.ngZone.run(() => this.resetTimer(false));
      }
    };
  }

  public startMonitoring(): void {
    this.resetTimer();
    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event =>
      window.addEventListener(event, this.handleActivity.bind(this), true)
    );
  }

  private handleActivity(): void {
    this.resetTimer();
    this.activityChannel.postMessage('activity');
  }

  private resetTimer(broadcast: boolean = true): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => this.handleInactivity(), this.timeoutMs);        
  }

  private handleInactivity(): void {
    this.authService.logout();
    this.router.navigate(['/denied']);    
  }
}
